import { useState, useEffect } from 'react';
import { useParams } from 'react-router';
import { useApi } from '../../../hooks/use-api';
import { moduleClientFactory } from '../../../api-service/module-client-factory';
import { IContactPersonLookup } from './interfaces';

interface InputParams {
  input: string;
  fetchMinimumInputLength: number;
  initialValue?: IContactPersonLookup[];
  maxResultSize: number | undefined;
}

export const useFetch = (params: InputParams) => {
  const { input, fetchMinimumInputLength, initialValue, maxResultSize } = params;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [data, setData] = useState<IContactPersonLookup[]>(initialValue ?? []);

  const { companyId } = useParams();
  const lookupClient = moduleClientFactory.createLookupContactPersonClient();
  const contactPersonLookupApi = useApi((cancelToken, query: string) => lookupClient.getContactPersonsByLookupQuery({ query, companyId, maxResultSize }, cancelToken), {
    contactPersons: [],
  });

  useEffect(() => {
    if (input.length >= fetchMinimumInputLength) {
      setLoading(true);

      const search = async () => {
        try {
          const response = await contactPersonLookupApi.invoke(input);
          setData(response.result.contactPersons ?? []);
        } catch (err: any) {
          setError(err);
        } finally {
          setLoading(false);
        }
      };
      search();
    } else {
      setData(initialValue ?? []);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [input]);

  return { loading, data, error };
};
